import { useContext, useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Col, Avatar, Menu, Dropdown } from "antd-v4";
import { RiArrowLeftSLine, RiLogoutBoxRLine, RiTranslate2, RiMoonLine, RiSettingsLine } from "react-icons/ri";
import { FirebaseContext } from "../../../../context/firebaseContext";
import { useCustomise } from "../../../../context/customiseContext";

export default function MenuFooter(props) {

  const { language, setLanguage } = useCustomise();
  const { userData, signOutUser } = useContext(FirebaseContext);
  const navigate = useNavigate();

  const [menuContent, setMenuContent] = useState('main');
  const [menuVisible, setMenuVisible] = useState(false);
  const [theme, setTheme] = useState(localStorage.getItem("theme") || "light");
  const [activeLanguage, setActiveLanguage] = useState(language);

  // Handle theme
  useEffect(() => {
    // Synchro avec un systeme externe au rendu (DOM, storage, timer, toast,
    // navigation) : l'etat accompagne un effet de bord qui ne peut pas remonter au rendu.
    // eslint-disable-next-line react/set-state-in-effect
    setTheme(localStorage.getItem("theme") || "light");
  }, []);

  useEffect(() => {
    document.body.setAttribute('data-theme', theme);
    localStorage.setItem("theme", theme);
  }, [theme]);

  // Handle lang
  useEffect(() => {
    // Synchro avec un systeme externe au rendu (DOM, storage, timer, toast,
    // navigation) : l'etat accompagne un effet de bord qui ne peut pas remonter au rendu.
    // eslint-disable-next-line react/set-state-in-effect
    setActiveLanguage(localStorage.getItem("lp-lang") || language);
  }, [language, activeLanguage]);

  const handleLanguage = (lang) => {
    switch (lang) {
    case 'fr':
      setLanguage('fr');
      localStorage.setItem("lp-lang", "fr");
      break;
    case 'en':
      setLanguage('en');
      localStorage.setItem("lp-lang", "en");
      break;
    default:
      break;
    }
    hideMenu();
  }

  const showMenu = () => setMenuVisible(true);
  const hideMenu = () => setMenuVisible(false);
  const handleVisibleChange = flag => setMenuVisible(flag);

  const handleMenuClick = (e) => {
    e.domEvent.stopPropagation();
    switch (e.key) {
    case 'language':
      setMenuContent('language');
      break;
    case 'appearance':
      setMenuContent('theme');
      break;
    case 'back':
      setMenuContent('main');
      break;
    case 'logout':
      hideMenu();
      signOutUser();
      navigate("/");
      break;
    default:
      setMenuContent('main');
    }
  };

  const handleThemeChange = (newTheme) => {
    setTheme(newTheme);
    window.location.reload(false);
  };

  const languageMenu = (
    <Menu onClick={handleMenuClick} selectedKeys={[activeLanguage]}>
      <Menu.Item key="back">
        <RiArrowLeftSLine /> Retour
      </Menu.Item>
      <Menu.Item key="fr" onClick={() => handleLanguage('fr')}>
        <p style={{margin: "0"}}>Français</p>
      </Menu.Item>
      <Menu.Item key="en" onClick={() => handleLanguage('en')}>
        <p style={{margin: "0"}}>Anglais</p>
      </Menu.Item>
    </Menu>
  );

  const themeMenu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="back">
        <RiArrowLeftSLine /> Retour
      </Menu.Item>
      <Menu.Item key="theme-device" onClick={() => handleThemeChange(window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light')}>
        <p style={{margin: "0"}}>Thème de l'appareil</p>
      </Menu.Item>
      <Menu.Item key="theme-light" onClick={() => handleThemeChange('light')}>
        <p style={{margin: "0"}}>Thème clair</p>
      </Menu.Item>
      <Menu.Item key="theme-dark" onClick={() => handleThemeChange('dark')}>
        <p style={{margin: "0"}}>Thème sombre</p>
      </Menu.Item>
    </Menu>
  );

  const mainMenu = (
    <Menu onClick={handleMenuClick}>
      <Menu.Item key="info" icon={<RiSettingsLine />}>
        <Link to="/profile/personal-information" onClick={props.onClose}>
          Paramètres
        </Link>
      </Menu.Item>
      <Menu.Item key="language" icon={<RiTranslate2 />}>
        Langue : {activeLanguage === 'fr' ? 'Français' : 'Anglais'}
      </Menu.Item>
      <Menu.Item key="appearance" icon={<RiMoonLine />}>
        Apparence : {theme === 'light' ? 'Thème clair' : 'Thème sombre'}
      </Menu.Item>
      <Menu.Item key="logout">
        <div className="logout-button" onClick={() => { signOutUser(); navigate("/"); }}>
          <RiLogoutBoxRLine /> Se déconnecter
        </div>
      </Menu.Item>
    </Menu>
  );

  const getCurrentMenu = () => {
    switch (menuContent) {
    case 'language':
      return languageMenu;
    case 'theme':
      return themeMenu;
    default:
      return mainMenu;
    }
  };

  const avatarDropdown = (
    <Dropdown
      overlay={getCurrentMenu()}
      trigger={['click']}
      placement="topLeft"
      open={menuVisible}
      onOpenChange={handleVisibleChange}
    >
      <a onClick={showMenu}>
        <Col
          className="hp-sidebar-footer"
          align="middle"
          justify="center">
          <Avatar
            size={48}
            src={userData && userData.avatar ? userData.avatar : 'path/to/default/avatar.png'}
            className="hp-bg-info-4"
          />
          {props.collapsed === false && (
            <div className="hp-mt-12">
              <span className="hp-d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body hp-font-weight-600" style={{ lineHeight: 1 }}>
                {userData?.firstname && userData?.firstname + " " + userData?.lastname}
              </span>
              <span className="hp-d-block hp-text-color-black-100 hp-text-color-dark-0 hp-p1-body hp-mt-6" style={{ lineHeight: 1 }}>
                {userData?.email}
              </span>
            </div>
          )}
        </Col>
      </a>
    </Dropdown>
  );

  return (
    <div className="hp-sidebar-footer " style={{ textAlign: 'center', padding: '10px' }}>
      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '30px' }}>
        {avatarDropdown}
      </div>
    </div>
  );
}
